{
  "version": 1,
  "asset_id": "56617cd4-7d9d-429e-a725-ff30ffc40381",
  "project_id": "f9ca952a-2109-492f-a7b0-0345b2dfa2e1",
  "url": "/__l5e/assets-v1/56617cd4-7d9d-429e-a725-ff30ffc40381/ndlcs-services-explainer.mp4",
  "r2_key": "a/v1/f9ca952a-2109-492f-a7b0-0345b2dfa2e1/56617cd4-7d9d-429e-a725-ff30ffc40381/ndlcs-services-explainer.mp4",
  "original_filename": "ndlcs-services-explainer.mp4",
  "size": 7496966,
  "content_type": "video/mp4",
  "created_at": "2026-07-02T18:12:53Z"
}
